import React, { useState, useEffect } from 'react'
import { Table } from 'react-bootstrap'
import { Formik } from 'formik'
import Select from 'react-select'
import axiosProvider from '../../../lib/AxiosProvider'
import Loader from '../../../components/Loader'
import { customStyles } from '../../../components/customStyles'
import CustomToast from '../../../components/Toast/CustomToast'
import IpCheckbox from '../../../components/IpCheckbox'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import { _SwalDelete, _exception } from '../../../lib/exceptionMessage'
import { showToast } from '../../../lib/AllGlobalFunction'

const RoleTypeWiseList = () => {
  const [roleType, setRoleType] = useState([])
  const [loading, setLoading] = useState(false)
  const { userInfo } = useSelector((state) => state?.user)
  const location = useLocation()
  const initValForTable = {}
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })

  const fetchData = async (id, setFieldValue) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'GET',
        endpoint: 'PageModule',
        queryString: `?pageSize=0&pageIndex=0`
      })
      setLoading(false)
      if (response?.status === 200) {
        let pageModuleArray = response?.data?.data
        let unionArr = response?.data?.data
        const apiResponse = await axiosProvider({
          method: 'GET',
          endpoint: 'AssignPageRolesByRoleType',
          queryString: `?Id=${id}`
        })

        if (apiResponse?.status === 200) {
          let pageModuleIdArray = apiResponse?.data?.data
          unionArr = pageModuleIdArray.concat(
            pageModuleArray.filter(
              (obj2) =>
                !pageModuleIdArray.find((obj1) => obj1.pageRoleId === obj2.id)
            )
          )
        }

        setFieldValue('pageRoleData', unionArr)
      }
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  const getRoleTypes = async () => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'GET',
        endpoint: 'GetAllRoleTypes',
        queryString: `?pageindex=0&PageSize=0`
      })
      setLoading(false)
      if (response?.status === 200) {
        setRoleType(response?.data?.data)
      }
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  const changeRight = async (data, setFieldValue, pageModuleArray) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'POST',
        endpoint: 'AssignPageRoles',
        data: data,
        location: location?.pathname,
        userId: userInfo?.userId
      })
      setLoading(false)

      if (response?.data?.code === 200) {
        let pageModule = pageModuleArray?.map((page) => {
          if (page?.pageRoleId === data?.pageRoleId) {
            return data
          } else {
            return page
          }
        })
        setFieldValue('pageRoleData', pageModule)
      }
      showToast(toast, setToast, response)
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  useEffect(() => {
    getRoleTypes()
  }, [])

  return (
    <>
      <Formik initialValues={initValForTable}>
        {({ values, setFieldValue }) => (
          <>
            <div className='d-flex align-items-center mb-3 gap-3'>
              <div className='input-select-wrapper flex-fill'>
                <label className='form-label'>Select Role Type</label>
                <Select
                  id='countryID'
                  menuPortalTarget={document.body}
                  menuPosition={'fixed'}
                  styles={customStyles}
                  options={roleType
                    ?.filter((item) => item?.name !== 'Super Admin')
                    ?.map(({ id, name }) => ({
                      value: id,
                      label: name
                    }))}
                  onChange={(e) => {
                    if (e) {
                      fetchData(e?.value, setFieldValue)
                      setFieldValue('roleTypeId', e?.value)
                    }
                  }}
                />
              </div>
            </div>

            {values?.pageRoleData?.length > 0 && (
              <Table responsive hover className='align-middle table-list'>
                <thead>
                  <tr>
                    <th>Page Name</th>
                    <th className='text-center'>Select All</th>
                    <th className='text-center'>View</th>
                    <th className='text-center'>Add</th>
                    <th className='text-center'>Edit</th>
                    <th className='text-center'>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {values?.pageRoleData?.map((data, index) => (
                    <tr key={Math.floor(Math.random() * 1000000)}>
                      <td>
                        {data?.pageRoleId ? data?.pageRoleName : data?.name}
                      </td>
                      <td className='text-center'>
                        <IpCheckbox
                          checkboxid={`${data?.pageRoleId}${Math.floor(
                            Math.random() * 100000
                          )}`}
                          value='read'
                          checked={
                            data?.read &&
                            data?.add &&
                            data?.delete &&
                            data?.update
                              ? true
                              : false
                          }
                          changeListener={(e) => {
                            let tempData = data?.pageRoleId
                              ? {
                                  ...data,
                                  read: e?.checked,
                                  add: e?.checked,
                                  delete: e?.checked,
                                  update: e?.checked,
                                  selectAll: e?.checked,
                                  userID: null,
                                  roleTypeId: data?.roleTypeId
                                    ? data?.roleTypeId
                                    : values?.roleTypeId
                                }
                              : {
                                  pageRoleId: data?.id,
                                  roleTypeId: values?.roleTypeId,
                                  pageRoleName: data?.name,
                                  read: e?.checked,
                                  add: e?.checked,
                                  delete: e?.checked,
                                  udpate: e?.checked,
                                  selectAll: e?.checked,
                                  userID: null
                                }
                            changeRight(
                              tempData,
                              setFieldValue,
                              values?.pageRoleData
                            )
                          }}
                        />
                      </td>

                      <td className='text-center'>
                        <IpCheckbox
                          checkboxid={`${data?.pageRoleId}${Math.floor(
                            Math.random() * 100000
                          )}`}
                          value='read'
                          checked={data?.read ? true : false}
                          changeListener={(e) => {
                            if (data?.add || data?.update || data?.delete) {
                              if (!e?.checked) {
                                Swal.fire({
                                  title: 'Cannot Remove View Permission!',
                                  text: `Cannot Remove View Permission: Other permissions ${
                                    data?.add ? 'Create' : ''
                                  } ${data?.update ? 'Update' : ''} ${
                                    data?.delete ? 'Delete' : ''
                                  } already granted.`,
                                  icon: _SwalDelete.icon,
                                  showCancelButton:
                                    _SwalDelete.showCancelButton,
                                  confirmButtonColor:
                                    _SwalDelete.confirmButtonColor,
                                  cancelButtonColor:
                                    _SwalDelete.cancelButtonColor,
                                  confirmButtonText: 'Yes',
                                  cancelButtonText: _SwalDelete.cancelButtonText
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    let tempData = data?.pageRoleId
                                      ? {
                                          ...data,
                                          read: e?.checked,
                                          add: false,
                                          delete: false,
                                          update: false,
                                          userID: null,
                                          roleTypeId: data?.roleTypeId
                                            ? data?.roleTypeId
                                            : values?.roleTypeId
                                        }
                                      : {
                                          pageRoleId: data?.id,
                                          roleTypeId: values?.roleTypeId,
                                          pageRoleName: data?.name,
                                          read: e?.checked,
                                          add: false,
                                          delete: false,
                                          udpate: false,
                                          userID: null
                                        }
                                    changeRight(
                                      tempData,
                                      setFieldValue,
                                      values?.pageRoleData
                                    )
                                  } else if (result.isDenied) {
                                  }
                                })
                              } else {
                                let tempData = data?.pageRoleId
                                  ? {
                                      ...data,
                                      read: e?.checked,
                                      userID: null,
                                      roleTypeId: data?.roleTypeId
                                        ? data?.roleTypeId
                                        : values?.roleTypeId
                                    }
                                  : {
                                      pageRoleId: data?.id,
                                      roleTypeId: values?.roleTypeId,
                                      pageRoleName: data?.name,
                                      read: e?.checked,
                                      add: false,
                                      delete: false,
                                      udpate: false,
                                      userID: null
                                    }
                                changeRight(
                                  tempData,
                                  setFieldValue,
                                  values?.pageRoleData
                                )
                              }
                            } else {
                              let tempData = data?.pageRoleId
                                ? {
                                    ...data,
                                    read: e?.checked,
                                    userID: null,
                                    roleTypeId: data?.roleTypeId
                                      ? data?.roleTypeId
                                      : values?.roleTypeId
                                  }
                                : {
                                    pageRoleId: data?.id,
                                    roleTypeId: values?.roleTypeId,
                                    pageRoleName: data?.name,
                                    read: e?.checked,
                                    add: false,
                                    delete: false,
                                    udpate: false,
                                    userID: null
                                  }
                              changeRight(
                                tempData,
                                setFieldValue,
                                values?.pageRoleData
                              )
                            }
                          }}
                        />
                      </td>

                      <td className='text-center'>
                        <IpCheckbox
                          checkboxid={`${data?.pageRoleId}${Math.floor(
                            Math.random() * 100000
                          )}`}
                          value='add'
                          checked={data?.add ? true : false}
                          changeListener={(e) => {
                            let tempData = data?.pageRoleId
                              ? {
                                  ...data,
                                  add: e?.checked,
                                  read: data?.read ? data?.read : e?.checked,
                                  userID: null,
                                  roleTypeId: data?.roleTypeId
                                    ? data?.roleTypeId
                                    : values?.roleTypeId
                                }
                              : {
                                  pageRoleId: data?.id,
                                  roleTypeId: values?.roleTypeId,
                                  add: e?.checked,
                                  read: e?.checked,
                                  delete: false,
                                  udpate: false,
                                  userID: null
                                }
                            changeRight(
                              tempData,
                              setFieldValue,
                              values?.pageRoleData
                            )
                          }}
                        />
                      </td>

                      <td className='text-center'>
                        <IpCheckbox
                          checkboxid={`${data?.pageRoleId}${Math.floor(
                            Math.random() * 100000
                          )}`}
                          value='update'
                          checked={data?.update ? true : false}
                          changeListener={(e) => {
                            let tempData = data?.pageRoleId
                              ? {
                                  ...data,
                                  update: e?.checked,
                                  read: data?.read ? data?.read : e?.checked,
                                  userID: null,
                                  roleTypeId: data?.roleTypeId
                                    ? data?.roleTypeId
                                    : values?.roleTypeId
                                }
                              : {
                                  pageRoleId: data?.id,
                                  roleTypeId: values?.roleTypeId,
                                  update: e?.checked,
                                  add: false,
                                  delete: false,
                                  read: e?.checked,
                                  userID: null
                                }
                            changeRight(
                              tempData,
                              setFieldValue,
                              values?.pageRoleData
                            )
                          }}
                        />
                      </td>

                      <td className='text-center'>
                        <IpCheckbox
                          checkboxid={`${data?.pageRoleId}${Math.floor(
                            Math.random() * 100000
                          )}`}
                          checked={data?.delete ? true : false}
                          value='delete'
                          changeListener={(e) => {
                            let tempData = data?.pageRoleId
                              ? {
                                  ...data,
                                  delete: e?.checked,
                                  read: data?.read ? data?.read : e?.checked,
                                  userID: null,
                                  roleTypeId: data?.roleTypeId
                                    ? data?.roleTypeId
                                    : values?.roleTypeId
                                }
                              : {
                                  pageRoleId: data?.id,
                                  roleTypeId: values?.roleTypeId,
                                  delete: e?.checked,
                                  add: false,
                                  read: e?.checked,
                                  udpate: false,
                                  userID: null
                                }
                            changeRight(
                              tempData,
                              setFieldValue,
                              values?.pageRoleData
                            )
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </>
        )}
      </Formik>

      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}

      {loading && <Loader />}
    </>
  )
}

export default RoleTypeWiseList
